import classNames from "classnames";
import { SideNavRowActive, SideNavRowTarget } from "./SideNavRowTarget";
import { SideNavStatus } from "./SideNavStatus";
import type { SideNavSubItemProps } from "./SideNav.types";
import styles from "./SideNavSubItem.module.scss";

export type { SideNavSubItemProps } from "./SideNav.types";

/**
 * A 24px child row of an expanded `SideNavItem`. With `status` it draws the
 * glyph in the parent's icon column, inside its own fill (client task rows),
 * instead of hanging off the tree line; `meta` is short trailing text such as "1h".
 */
export const SideNavSubItem = (props: SideNavSubItemProps) => {
    const {
        label,
        labelCopyId,
        labelCopyLabel,
        status,
        meta,
        isActive: isActiveOverride,
        className,
        ref,
        "data-forced-state": forcedState,
    } = props;

    return (
        <SideNavRowActive target={props} isActive={isActiveOverride}>
            {(isActive) => (
                <div
                    ref={ref}
                    className={classNames(styles.subItem, className)}
                    data-active={isActive || undefined}
                    data-status={status}
                    data-forced-state={forcedState}
                >
                    <SideNavRowTarget
                        target={props}
                        isActive={isActive}
                        label={label}
                        labelCopyId={labelCopyId}
                        labelCopyLabel={labelCopyLabel}
                        leading={
                            status === undefined ? undefined : (
                                <SideNavStatus status={status} />
                            )
                        }
                        className={styles.target}
                        labelClassName={styles.label}
                    />
                    {meta !== undefined && (
                        <span className={styles.meta}>{meta}</span>
                    )}
                </div>
            )}
        </SideNavRowActive>
    );
};
